import React, {useRef, useState, useEffect, useContext} from 'react';
import {Grid} from '@material-ui/core';
import {properties, texts} from './ListadoNoticiasData';
import {properties as appProperties} from '../../../AppData';
import {customStyle} from './ListadoNoticiasStyle';
import SearchBar from '../../commons/searchBar/SearchBar';
import Pager from '../../commons/pager/Pager';
import {properties as propertiesSearchBar} from '../../commons/botonera/BotoneraVerticalData';
import Noticia from '../../commons/noticia/Noticia';
import {CircularProgress, Backdrop} from '@material-ui/core';
import RestProvider from 'providers/RestProvider';
import AppContext from 'AppContext';

export default function ListadoNoticias() {

    //HOOKS
    const [isLoading, setIsLoading] = useState(false);
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [noticias, setNoticias] = useState([]);
    const [noticiasFiltradas, setNoticiasFiltradas] = useState([]);
    const [setPhoneSelectedOption] = useState(propertiesSearchBar.DEFAULT_BUTTON);
    const refDefaultButtonBotonera = useRef(null);
    const refAutocomplteSearchBar = useRef(null);
    const [currentPage, setCurrentPage] = useState(properties.INIT_PAGE);
    const context = useContext(AppContext);
    const {crudOperation, crudOperationsType} = RestProvider();


    //LLAMADAS
    useEffect(() => {
        updateFormat();
        getDataNoticias();
        context.updateTitlePage(texts.PAGE_TITLE);
    }, []) ;

    //Efecto que se ejecuta cada vez que se pase de página
    useEffect(() => {
        //Se comprueba si existe el elemento padre que contiene las noticias en el DOM
        if (document.querySelector('#contenedorNoticias')){
            let noticias = document.querySelector('#contenedorNoticias');
            cerrarNoticias(noticias);
        }
    }, [currentPage]);

    /**Llamada al microservicio de moad-api-proxy para recuperar el listado de noticias 
    */
    const getDataNoticias = async () => {
        setIsLoading(true);
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url: properties.URL_GET_NOTICIAS, method: 'get'}).then(response => {
            setNoticias(response.data);
            setNoticiasFiltradas(response.data);
        }).catch(function (error) {
            setIsLoading(false);      
        }).finally(function () {
            setIsLoading(false);
        })
    }

    //FUNCIONES
    /**Método que actualiza la página actual en la que se encuentra */
    const paginate = pageNumber => {
        let previousPage = currentPage;
        setCurrentPage(pageNumber);
        return previousPage;
    }

    /**Método que actualiza las noticias que se están mostrando actualmente */
    const updateSearch = value => {
        setNoticiasFiltradas(value);
    }

    /**Método que actualiza el elemento selecionado en el select de tipos
    ***de noticias en versión movil*/
    const updatePhoneSelectedOption = value => {
        setPhoneSelectedOption(value);
    }

        
    /**Método que renderiza el paginador solo en versión ordenador */
    const renderPager = () =>{
        if(!isPhoneVersion){
            return <Grid item>
                <Pager recordsPerPage={properties.RECORDS_PER_PAGE} totalRecords={noticiasFiltradas.length} currentPage={currentPage} paginate={paginate} numFilasPersonalizado={false}/>
            </Grid>
        }   
    }

    /**Método que capta el tamaño de la ventana y actualiza actualiza
    ***el hook que controla cuando se da el salto a versión movil*/
   const updateFormat = () => {
        if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    };

    const mostrarLineaNoticia = index => {
        if(index + 1 != noticiasMostradas.length){
            return <hr className={() => customStyle().classLine1}/>
        }
    }

    const mostrarNoticia = () =>{
        return noticiasMostradas && noticiasMostradas.map((noticia, index) =>{
            return (
            <Grid className={'noticia'}>
                <Noticia titular = {noticia.nombreAvisoNoticia}
                    fecha = {noticia.fechaInicioParse}
                    texto = {noticia.descripcion}
                    isPhone = {isPhoneVersion}      
                />
                {mostrarLineaNoticia(index)}
            </Grid>
            )
        })
    }

    /**
     * @function cerrarNoticias Método utilizado para cerrar las noticias
     * @param {*} noticias Recibe el elemento del DOM que contiene todas las noticias (divs)
     */
    const cerrarNoticias = async (noticias) => {
        //Paso 1. Se obtienen todos los hijos del elemento padre que las contiene
        noticias = noticias['childNodes'];
        //Paso 2. Se recorren todas las noticias. **A las noticias se le resta 1, ya que el contenedor padre, también contiene en el el paginador. 
        for (let i = 0; i < (noticias.length - 1); i++) {
            //Paso 3. Se obtiene el elementod del DOM de la noticia, en cada iteracción se va obteniendo la siguiente noticia
            let noticia = `div.noticia:nth-child(${i+1}) > div:nth-child(1) > div:nth-child(4) > div:nth-child(1)`;
            //Paso 4. Se evalúa si la noticia está desplegada, en caso de que lo esté se pulsará click sobre ella para que se repliegue y oculte su contenido
            if (document.querySelector(noticia)['attributes']['aria-expanded']['nodeValue'] === 'true') {
                await document.querySelector(noticia).click();
            }
        }
    }
      
    const indexOfLastRecord = currentPage * properties.RECORDS_PER_PAGE;
    const indexOfFirstRecord = indexOfLastRecord - properties.RECORDS_PER_PAGE;    
    let noticiasMostradas = isPhoneVersion ? noticiasFiltradas : noticiasFiltradas.slice(indexOfFirstRecord, indexOfLastRecord);

    return (
        <Grid container direction='column'  justify='space-between'>
            <Grid container direction={isPhoneVersion ? 'column-reverse' : 'row'} justify='space-between'>
                <Grid item className={customStyle().gridPageTitle}>
                    <h2 id="tituloPagina" className={customStyle().pageTitle}>{texts.PAGE_TITLE}</h2>
                </Grid>
                <Grid item className={customStyle().gridSearchBar}>
                    <div className='x'><SearchBar data={noticias} updateSearch={updateSearch} updatePhoneSelectedOption={updatePhoneSelectedOption} refDefaultButtonBotonera={refDefaultButtonBotonera} refAutocomplteSearchBar={refAutocomplteSearchBar} paginate={paginate} isPhoneVersion={isPhoneVersion}/></div> 
                </Grid>                
            </Grid>
            <div className={customStyle().backgroundRectangle}>
                <Grid container direction='row'  justify='space-around'>
                    <Grid item className={isPhoneVersion ? customStyle().gridTableResponsivePager : customStyle().gridTablePager} id={'contenedorNoticias'}>
                        {mostrarNoticia()}    
                        {renderPager()}                                                                    
                    </Grid>
                </Grid>
            </div>
            <Backdrop className={customStyle().classBackdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>                       
        </Grid>
    )
}
